import React, { useEffect, useState, useCallback } from 'react'
import { AppBar, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'

import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import StaffInfoCard from '../../../components/Cards/Staff/StaffInfoCard'
import StaffFirebaseClaimsCard from '../../../components/Cards/Staff/StaffFirebaseClaimsCard'
import StaffPasswordResetDialog from '../../../components/Dialogs/Staff/StaffPasswordResetDialog'
import { updateStaff, getStaffById } from '../../../actions/Team/team.actions'
import useCurrentUser from '../../../hooks/useCurrentUser'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '20px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	}
}))

const TeamMember = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()
	const location = useLocation()
	const { isSuperUser } = useCurrentUser()
	const showFirebase = isSuperUser && new URLSearchParams(location.search).get('showFirebase') === 'true'

	const staffMember = useSelector((state) => state.specific.team.selectedStaff)

	const loading = useSelector((state) => state.specific.team.loading)

	const [current, setCurrent] = useState(null)
	const [isSaveShown, setIsSaveShown] = useState(false)
	const [showPasswordResetDialog, setShowPasswordResetDialog] = useState(false)

	const handlePasswordResetClick = useCallback(() => {
		setShowPasswordResetDialog(true)
	}, [])
	const handlePasswordResetDialogClose = useCallback(() => {
		setShowPasswordResetDialog(false)
	}, [])

	useEffect(() => {
		if (!staffMember) {
			dispatch(getStaffById(params.staffId))
		}
	}, [])

	useEffect(() => {
		if (params.staffId && staffMember) {
			setCurrent(cloneDeep(staffMember))
		}
	}, [params.staffId, staffMember])

	useEffect(() => {
		if (current && staffMember) {
			let staffEqual = !isEqual(current, staffMember)

			setIsSaveShown(staffEqual)
		}
	}, [current, staffMember])

	const saveStaffMember = () => {
		let updates = { ...current }

		if (updates.contact.phone_number) updates.contact.phone_number = onlyNumbers(updates.contact.phone_number)

		dispatch(updateStaff(staffMember._id, updates, staffMember))
	}

	const clearChanges = () => {
		setCurrent(cloneDeep(staffMember))
	}

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	return (
		<div>
			{current ? (
				<Container className={classes.root} maxWidth="md">
					<div>
						<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
							{current.full_name}
						</Typography>
						<StaffInfoCard
							staffMember={current}
							setCurrent={setCurrent}
							onPasswordResetClick={handlePasswordResetClick}
						/>
						{showFirebase ? (
							<StaffFirebaseClaimsCard staffId={params.staffId} />
						) : null}
					</div>
					{isSaveShown ? (
						<AppBar position="fixed" color="primary" className={classes.appBar}>
							<Toolbar>
								<Container maxWidth="md">
									<Button
										variant="contained"
										color="secondary"
										disabled={
											loading || onlyNumbers(current?.contact?.phone_number)?.length !== 10
										}
										style={{ marginRight: '8px' }}
										onClick={() => saveStaffMember()}>
										Save Changes
									</Button>
									<Button variant="outlined" color="secondary" onClick={clearChanges}>
										Cancel
									</Button>
								</Container>
							</Toolbar>
						</AppBar>
					) : null}
				</Container>
			) : null}
			{loading ? <LoadingOverlay /> : null}
			<StaffPasswordResetDialog
				staffMember={current}
				open={showPasswordResetDialog}
				onClose={handlePasswordResetDialogClose}
			/>
		</div>
	)
}

export default TeamMember
